package link.erpango.quip.data.remote

import io.ktor.client.HttpClient
import link.erpango.quip.QuipConstants
import link.erpango.quip.data.DataSource
import link.erpango.quip.data.remote.ktor.RestConsumer

class ServerApiClient(
    private val dataSource: DataSource,
    urlResolver: ApiUrlResolver,
    client: HttpClient

): ApiClient(urlResolver, client) {

    /**
     * Personalizamos la url de cada petición para enviar en cada una de ellas información
     * útil como el app id o la versión.
     */
    override fun consume(url:String): RestConsumer {
        val newUrl = "$url"
        return super.consume(newUrl)
    }

    override val headers get() =
        mapOf(
            QuipConstants.Http.Headers.userAgent        to ("Mobile Quip"),
        )
}